var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "watermarkTransfer" } }, [
    _c("div", { staticClass: "check-item-positions" }, [
      _c("div", {
        staticClass: "icon-util",
        class: [_vm.delWatermark ? "check-small" : "nocheck-small-blue"],
        staticStyle: { float: "left" },
        on: {
          click: function($event) {
            _vm.delWatermark = !_vm.delWatermark
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "check-item-position" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("language.emailTransfer.delWatermark")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11773826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11773826","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_email_watermark.vue
// module id = null
// module chunks = 